//import libs
import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Header from "./Header";
import Sidebar from "./Sidebar";

function MemberGroupLayout({ children }) {
    // useEffect(() => {
    //     // if (isAuthenticated) {
    //     //     dispatch(userActions.getAuthUser());
    //     // }
    //     // function loginUserOnStartup() {
    //     //     const cookie = new Cookies();
    //     //     if (cookie.get("is_auth")) {
    //     //         axios
    //     //             .post("/api/me")
    //     //             .then((response) => {
    //     //                 setUserdata({
    //     //                     signedIn: true,
    //     //                     user: response.data.user,
    //     //                 });
    //     //                 navigate("/");
    //     //             })
    //     //             .catch((error) => {
    //     //                 setUserdata({ signedIn: false, user: null });
    //     //                 setLogout();
    //     //             });
    //     //     } else {
    //     //         setUserdata({ signedIn: false, user: null });
    //     //         navigate("/login");
    //     //     }
    //     // }
    // }, []);

    return (
        <Fragment>
            <div
                id="page-content-wrapper"
                className={`flex h-screen bg-gray-50 dark:bg-gray-900 "overflow-hidden"`}
            >
                <Sidebar />
                {/* container-fluid */}

                <div
                    className="w-full md:pl-1  lg:pl-64  overflow-auto  bg-white"
                    id="content-warp-box"
                >
                    <Header />
                    <div className="border-b-2 m-1 p-3" />
                    <style
                        dangerouslySetInnerHTML={{
                            __html: "a:hover{cursor: pointer;}",
                        }}
                    />
                    <div className="w-28 p-2 text-left hover:underline text-base"></div>
                    <div className="pl-6 pr-6" id="webmember-content-box">
                        <dev id="coop-content mb-0">{children}</dev>
                    </div>
                </div>
            </div>
            <div id="toTop" className="btn-totop text-center">
                <span>
                    <i
                        className="glyphicon glyphicon-chevron-up"
                        style={{
                            right: 1,
                            top: "-15px",
                            position: "relative",
                            color: "white",
                        }}
                    />
                </span>
            </div>
        </Fragment>
    );
}

const displayName = "MemberGroup Layout";
const propTypes = {
    children: PropTypes.node.isRequired,
};

MemberGroupLayout.dispatch = displayName;
MemberGroupLayout.propTypes = propTypes;

export default MemberGroupLayout;
